import { handleFundingCTA } from "@js/modules/domain/funding/cta";
import { handleFundingForm } from "@js/modules/domain/funding/form";


export const setupAllFundingDomain = () => {
	handleFundingCTA();
	handleFundingForm();
};
